/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFamilyMemberMedications = sqliteTable('patient_family_member_medications', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  family_member_id: text('family_member_id'),
  name: text('name'),
  dose: text('dose'),
  frequency: text('frequency'),
  status: text('status'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  updated_by: text('updated_by'),
});
